<template>
  <div class="d-flex flex-wrap">
    <!--- stockage selection--->
    <v-menu
        v-model='isOpened'
        :return-value="stockage_id"
        :close-on-content-click="true"
        :offset="0"
        >
        <template v-slot:activator="{props}">
          <v-btn
              height="70"
              spaced="both"
              :x-small="smAndDown"
              color="primary"
              dark
              v-bind="props"
              >
              <div>
                {{ stockage_name }}
              </div>
            <v-progress-circular
                class="ml-2"
                v-show="loading_"
                :indeterminate="true"
                ></v-progress-circular>
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-card scrollable>
          <v-card-text style="max-height: 50vh; overflow-y: scroll">
            <v-list>
              <v-list-item
                  v-for="item in stockages"
                  :key="item.stockage_id"
                  @click="chooseStockage(item)"
                  >
                  <v-list-item-title>{{ item.stockage_name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
    </v-menu>

    <!--- producer_type selection--->
    <v-btn
        height="70"
        append-icon="mdi-menu-down"
        spaced="both"
        color="primary"
        id='p_type_activator'
        :disabled='loading_ || !stockage_id'
        >
        <small class="mb-1">{{$t("producer_types.label", 1)}}:{{producer_type_name}}</small>
    </v-btn>
    <v-menu
        activator = "#p_type_activator"
        >
        <v-list>
          <v-list-item v-show="producer_type_id != undefined" @click='clearProducerType()' :title='$filters.capitalize($t("producer_types.all"))'></v-list-item>
          <v-list-item v-for="p_type in producer_types" :key="p_type.full_name" @click="selectProducerType(p_type)">
            <v-list-item-title>{{ p_type.producer_type_name }}</v-list-item-title>
          </v-list-item>
        </v-list>
    </v-menu>

    <!--- text search --->
    <v-spacer/>
      <v-text-field
          v-model="searchText"
          @input="onInput"
          label="Search"
          prepend-inner-icon="mdi-magnify"
          single-line
          variant="outlined"
          hide-details
          />
  </div>
</template>

<script>
  import { isNone } from "@/functions.js";
  import { useDisplay } from "vuetify";
  import { mapState } from "vuex";

  export default {

    emits: [
        'chooseStock',
        'updateSearchText',
    ],

    computed: {
      stockages(){
        return Array.from(
          new Map(
            this.stockage_items?.map(x => [x.stockage_name, { stockage_name: x.stockage_name, stockage_id: x.stockage_id }])
          ).values())
      },
      smAndDown(){
        return useDisplay().smAndDown.value
      },
      loading() {
        return this.$store.state.purchases.isLoading || this.$store.state.purchase_lines.isLoading
      },
      ...mapState({
        stockage_items: state => state.stockages.x_prod_type
      }),
    },
    created() {
      this.stockage_id = parseInt(this.$route.query.stockage_id) || undefined;
      this.producer_type_id = parseInt(this.$route.query.producer_type_id) || undefined;

      this.loadStockagesIfEmpty();

      if (!isNone(this.stockage_id)) {
        this.updateCurrentStockage(this.stockage_id);
      }
      if (!isNone(this.producer_type_id) && this.producer_types.length > 0) {
        this.updateCurrentProducerType(this.producer_type_id);
      }
    },

    methods: {
      onInput(e) {
        const txt = e.target.value
        this.$emit('updateSearchText', txt)
      },
      updateCurrentStockage(id) {
        const stockage = this.stockages.find(s => s.stockage_id === id);
        this.stockage_name = stockage
          ? stockage.stockage_name
          : this.$t('actions.choose_stock');
        this.updateProducerTypes(this.stockage_name)
      },
      updateProducerTypes(stockage_name) {
        this.loadStockagesIfEmpty();
        this.producer_types = this.stockage_items.filter(x => x.stockage_name == this.stockage_name)
      },

      updateCurrentProducerType(id) {
        this.updateProducerTypes();
        const producerT = this.producer_types.find( item => item.producer_type_id === id )
        this.producer_type_name = producerT
          ? producerT.producer_type_name
          : this.$t('producer_types.all');
      },

      chooseStockage(select) {
        this.updateCurrentStockage(select.stockage_id);
        this.stockage_id = select.stockage_id
        this.emitFilterValues()
      },
      emitFilterValues() {
        this.$emit("chooseStock", {
          stockage_id: this.stockage_id,
          producer_type_id: this.producer_type_id,
          producer_types: this.producer_types
        });
      },
      loadStockagesIfEmpty() {
        if (this.stockage_items?.length == 0) {
          this.$store.dispatch("stockages/getXProdType").then (()=>{
            this.updateCurrentStockage(this.stockage_id);
          })
        }
      },
      clearProducerType(){
        this.producer_type_id = undefined;
        this.producer_type_name = this.$t('producer_types.all');
        this.emitFilterValues()
      },
      selectProducerType(value){
        this.producer_type_id = value.producer_type_id
        this.producer_type_name = value.producer_type_name
        this.emitFilterValues()
      },
    },
    watch: {
      isOpened(val) {
        if (val)  this.loadStockagesIfEmpty();
      },
      stockage_id(newId) {
        this.emitFilterValues();
      },
      producer_type_id(newId) {
        this.updateCurrentProducerType(newId);
        this.emitFilterValues();
      },
    },

    data() {
      return {
        moduleName: "stockages",
        loading_: false,
        isOpened: false,
        stockage_id: undefined,
        stockage_name: this.$t("actions.choose_stock"),
        producer_types: [],
        producer_type_id: undefined,
        producer_type_name: this.$t('producer_types.all'),
        searchText: "",
      };
    },
  };
</script>
